import _ from "lodash";
import { ROLE_USER, STATUS_USER } from "../constants/app";
import {
  getFilterGroupList,
  getGroupChildren,
} from "../services/MachineServices";

// get select label fron options for select-input
const getSelectLabel = (options, value) => {
  if (!options) {
    return null;
  }
  let option = options.find(o => o.value === value);
  if (option) {
    return option.label;
  }
  return null;
}

// get position select options base on position assign for machine group
const getPositionOptions = (deparmentPositions, groupCombine) => {
  let positions = deparmentPositions.filter(position => {
    return (
      (groupCombine.group_1 === position.group_1?.id ||
        position.group_1 === null) &&
      (groupCombine.group_2 === position.group_2?.id ||
        position.group_2 === null) &&
      (groupCombine.group_3 === position.group_3?.id ||
        position.group_3 === null) &&
      (groupCombine.group_4 === position.group_4?.id ||
        position.group_4 === null) &&
      (groupCombine.group_5 === position.group_5?.id ||
        position.group_5 === null)
    );
  });

  return positions.map(data => {
    return {value: data.position.id, label: data.position.name}
  });
}

const getSelectedValue = (options, value, nullIsAll = false) => {
  if (!options) {
    return null;
  }
  let propName = 'value';
  let option = options.find(o => {return String(o[propName]) === String(value)});
  if (option) {
    return option;
  }
  if (nullIsAll) {
    return {value: null, label: '[ALL]'}
  }
  return null;
};

const getSelectedValueFilter = (options, value, nullIsAll = false) => {
  if (!options) {
    return null;
  }
  let propName = "value";
  let option = options.find((o) => {
    return String(o[propName]) === String(value);
  });
  if (option) {
    return option;
  }
  if (nullIsAll) {
    return { value: "", label: "[ALL]" };
  }
  return null;
};

const getSelectedGroupValueForTable = (options, value, nullIsAll = false) => {
  if (!options) {
    return null;
  }
  let propName = 'value';
  let option = options.find(o => {return String(o[propName]) === String(value)});
  if (option) {
    return option;
  }
  if (nullIsAll) {
    return {value: null, label: ''}
  }
  return null;
}

const getSelectedById = (options, value, labelProp) => {
  if (!options) {
    return null;
  }
  let option = options.find(o => {return String(o.id) === String(value)});
  if (option) {
    return {value: option.id, label: option[labelProp]}
  }
  return null;
}

const getChildGroupOptions = (groupsChildren, groupSelect, groupsList, hasAll = false) => {
  if (_.isEmpty(groupsList)) {
    return {
      1: [],
      2: [],
      3: [],
      4: [],
      5: [],
    }
  }
  let initOptions = [];
  if (hasAll) {
    initOptions = [{value: null, label:'[ALL]'}];
  }
  if (!groupSelect || groupSelect[1] === 0 || groupSelect[1] === null) {
    return {
      1: [...initOptions, ...groupsList[1]],
      2: [],
      3: [],
      4: [],
      5: [],
    };
  }
  const getChildren = (level) => {
    let parentLevel = level - 1;
    while(groupSelect[parentLevel] === 0 || groupSelect[1] === null) {
      parentLevel--;
    }
    let children = [];
    let parents = [groupSelect[parentLevel]];
    while(parentLevel < level) {
      children = [];
      for(let i = 0; i < parents.length; i++) {
        
        children = [...children, ...(groupsChildren[parents[i]]?? [])]
      }
      parentLevel++;
      parents = children.map(v => v.id);
    }
    return children;
  }
  let result = {
    1: [...initOptions, ...groupsList[1]],
    2: [],
    3: [],
    4: [],
    5: [],
  };
  for (let i = 2; i <= 5; i++) {
    let currentLevelChildren = getChildren(i);
    let levelSelect = currentLevelChildren.map(v => {
      return {value: v.id, label: v.name};
    });
    result[i] = [...initOptions, ...levelSelect];
  }
  return result;
};

const getChildGroupOptionsFilter = (
  initGroupOptions,
  filterOptions,
  filterData,
  firstSelected
) => {
  const result = {
    group_1: [{ value: "", label: "[ALL]" }],
    group_2: [{ value: "", label: "[ALL]" }],
    group_3: [{ value: "", label: "[ALL]" }],
    group_4: [{ value: "", label: "[ALL]" }],
    group_5: [{ value: "", label: "[ALL]" }],
  };
  if (_.isEmpty(filterOptions)) {
    return result;
  }
  if (firstSelected === 0) {
    return getFilterGroupList(initGroupOptions);
  }
  result["group_1"] = [...filterOptions["group_1"]];
  for (let i = 2; i <= 5; i++) {
    if (i <= firstSelected) {
      result[`group_${i}`] = [...filterOptions[`group_${i}`]];
    } else {
      let groupOptions = getGroupChildren(
        initGroupOptions,
        filterData,
        i
      );
      result[`group_${i}`] = [...groupOptions];
      if (filterData[`group_${i}`] === "") {
        break;
      }
    }
  }
  return result;
};

const allGroupIsEmpty = (data) => {
  return Object.keys(data)
    .filter((key) => key.startsWith("group_"))
    .every((key) => data[key] === "");
};

const getRoleUserOption = (hasAll = false) => {
  if (hasAll === false) {
    return [
      {
        value: ROLE_USER.USER,
        label: "一般ユーザー",
      },
      {
        value: ROLE_USER.MASTER_ADMIN,
        label: "ユーザーマスタ管理者",
      },
      {
        value: ROLE_USER.SUPER_ADMIN,
        label: "スーパーユーザー",
      }
    ]
  }

  return [
    {
      value: ROLE_USER.USER,
      label: "一般ユーザー",
    },
    {
      value: ROLE_USER.MASTER_ADMIN,
      label: "ユーザーマスタ管理者",
    },
    {
      value: ROLE_USER.SUPER_ADMIN,
      label: "スーパーユーザー",
    },
    {
      value: 10,
      label: "[ALL]",
    }
  ]
};

const getStatusUserOption = (hasAll = false) => {
  if (hasAll === false) {
    return [
      {
        value: STATUS_USER.ACTIVE,
        label: "有効",
      },
      {
        value: STATUS_USER.RESIGN,
        label: "無効",
      }
    ]
  }

  return [
    {
      value: STATUS_USER.ACTIVE,
      label: "有効",
    },
    {
      value: STATUS_USER.RESIGN,
      label: "無効",
    },
    {
      value: 10,
      label: "[ALL]",
    },
  ]
};

const getSelectedByValue = (options, value) => {
  if (!options) {
    return null;
  }
  let option = options.find(o => {return String(o.value) === String(value)});
  if (option) {
    return {value: option.value, label: option['label']}
  }
  return null;
}

const getSelectedGroupValue = (options, value, nullIsAll = false) => {
  if (!options) {
    return null;
  }
  if (Array.isArray(value)) {

  }
  let propName = 'value';
  let option = options.find(o => {return String(o[propName]) === String(value)});
  if (option) {
    return option;
  }
  if (Array.isArray(value)) {
    return options.find(o => {return value.includes(o[propName])});
  }
  if (nullIsAll) {
    return {value: null, label: '[ALL]'}
  }
  return null;
};

const formatUserOptions = (users) => {
  if (!users || users.length === 0) {
    return []
  }

  return users.map(user => ({
    value: user.id,
    label: `${user.name} (${user.username})`
  }))
};

const convertToOptions = (data) => {
  if (!data || data.length === 0) {
    return [];
  }

  return data.map((item) => ({
    value: item.id,
    label: item.name,
  }));
};

export {
  getSelectLabel,
  getPositionOptions,
  getRoleUserOption,
  getStatusUserOption,
  getSelectedValue,
  getChildGroupOptions,
  getSelectedById,
  getSelectedByValue,
  getSelectedGroupValueForTable,
  getSelectedValueFilter,
  getChildGroupOptionsFilter,
  getSelectedGroupValue,
  allGroupIsEmpty,
  formatUserOptions,
  convertToOptions
};
